export const getDownloads = (state, downloads) => {
  state.downloads = downloads
}

export const setLoading = (state, value) => {
  state.loading = value;
}